import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import toast from 'react-hot-toast';
import { HSL } from './colors';

function MissingMbtiBanner({ count }) {
  if (!count || count <= 0) return null;

  const handleReview = () => {
    toast('Open the Students tab to resolve missing MBTI types.', {
      icon: 'ℹ',
    });
  };

  return (
    <Alert
      severity="warning"
      variant="outlined"
      action={
        <Button
          size="small"
          onClick={handleReview}
          sx={{
            color: HSL.warning,
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { backgroundColor: HSL.warningSoft },
          }}
        >
          Review
        </Button>
      }
      sx={{
        borderColor: HSL.warning,
        color: HSL.textStrong,
        backgroundColor: HSL.warningSoft,
        borderRadius: '8px',
        mb: 2,
        '& .MuiAlert-icon': { color: HSL.warning },
      }}
    >
      <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>
        Missing MBTI types
      </AlertTitle>
      {`${count} learner${
        count === 1 ? '' : 's'
      } missing MBTI — assign a type or mark them excluded before T+7.`}
    </Alert>
  );
}

export default MissingMbtiBanner;
